// 해당 파일은, 디플로이시 자동으로 새로 작성되므로, config.js 파일을 직접 수정하지 말것.
window.GRIDA_VERSION = "0.2.4";
console.log("%cGRIDA_VERSION : " + window.GRIDA_VERSION, "color:#FF9999;font-size:25px");
